import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    userData: null,
    token: localStorage.getItem('token'),
    group_pertama: {},
    group: [],
    menu_program: [],
    error: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        loginSuccess(state, action) {
            state.userData = action.payload.user;
            state.token = action.payload.token;
            state.group_pertama = action.payload.group_pertama;
            state.group = action.payload.group;
            state.menu_program = action.payload.menu_program;
            state.error = null;
            localStorage.setItem('token', action.payload.token); // Menyimpan token ke localStorage
        },
        loginFailure(state, action) {
            state.userData = null;
            state.token = null;
            state.error = action.payload;
            state.group_pertama = null;
            state.group = [];
            state.menu_program = null;

            localStorage.removeItem('token'); // Menghapus token dari localStorage jika login gagal
        },
        updateMenuProgram(state, action) {
            state.menu_program = action.payload;
        },
        logout(state) {
            state.userData = null;
            state.token = null;
            state.error = null;
            state.menu_program = null;
            state.group_pertama = null;
            state.group = [];
            localStorage.removeItem('token'); // Menghapus token dari localStorage saat logout
        },
    },
});

export const { loginSuccess, loginFailure, logout, updateMenuProgram } = authSlice.actions;
export default authSlice.reducer;
